import { useEffect, useState } from 'react';

import { ListItemButton, Typography } from '@mui/material';
import { getPatients } from 'apis/admin';
import { ReactComponent as Cookie } from 'assets/alarm-icon.svg';
import { ReactComponent as Empty } from 'assets/alarm-icon-empty.svg';

import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';

import MuiAutocomplete from 'components/MuiAutocomplete';

interface IOption {
  patient_id: string;
  name: string;
  age: string;
  patient_private?: boolean;
}

const CollegePatientList = ({ user_id }: { user_id: number }) => {
  const { onSelectedPatient } = usePatient();
  const { student_uuid } = useStudent();

  const optionLabel = ({ patient_id, name }: IOption) =>
    `${patient_id} ${name}`;

  const Option = ({
    patient_id,
    name,
    age,
    patient_private,
    ...props
  }: IOption) => {
    const [nursingRecord, setNursingRecord] = useState([]);

    // patient_private에 따른 스타일 적용
    const customStyles = patient_private
      ? { backgroundColor: '#E0E0E0', color: '#00000080' }
      : {};

    if (nursingRecord.length === 0) {
      return (
        <ListItemButton {...props} sx={{ gap: 0.5, ...customStyles }}>
          <Empty />
          <Typography variant="subtitle2">{patient_id}</Typography>
          <Typography variant="caption" color="inherit">
            {name}
          </Typography>
          <Typography variant="caption" color="inherit">
            {age}
          </Typography>
        </ListItemButton>
      );
    } else {
      return (
        <ListItemButton {...props} sx={{ gap: 0.5, ...customStyles }}>
          <Cookie />
          <Typography variant="subtitle2">{patient_id}</Typography>
          <Typography variant="caption" color="inherit">
            {name}
          </Typography>
          <Typography variant="caption" color="inherit">
            {age}
          </Typography>
        </ListItemButton>
      );
    }
  };

  return (
    <MuiAutocomplete
      variant="standard"
      valueKey="patient_id"
      listKey="admin_patients"
      placeholder=" 病患查詢"
      noOptionsText="no patients found. please enter another patient name"
      getOptionLabel={optionLabel}
      renderOption={(props, option) => <Option {...props} {...option} />}
      onChange={onSelectedPatient}
      getApi={request => getPatients({ user_id, ...request })}
    />
  );
};

export default CollegePatientList;
